import DetailElement from './DetailElement';

export default DetailElement;
